import * as React from 'react';
import { Page, PageContent, PageHeader } from '../components/common';
import { Link } from 'react-router-dom';

interface Props {}
const ComplaintsPage: React.StatelessComponent<Props> = props => {
	return (
		<Page>
			<PageContent>
				<PageHeader title="HOW TO FILE A COMPLAINT" />
				<h2 className="h4 border-bottom text-uppercase">Introduction</h2>
				<p>Taking care of our customers is our highest priority. If you think we’ve gotten
					something wrong, please let us know by following the steps below. We promise to handle
					your complaint in a professional and courteous manner, guided by the following principles:</p>
				<ul className="list-unstyled ml-3 ml-md-4">
					<li className="mb-3">
						<strong className="text-uppercase mr-2">Culture.</strong>
						We welcome your feedback as a way to make sure we take care of our customers. If we’ve dropped
						the ball, we’ll put things right, and we’ll make sure we do better next time.
					</li>
					<li className="mb-3">
						<strong className="text-uppercase mr-2">Accountablity.</strong>
						We want to be open and honest when accounting for our decisions and actions.
					</li>
					<li className="mb-3">
						<strong className="text-uppercase mr-2">Procedure.</strong>
						We will investigate your complaint thoroughly and fairly according to the procedure set out in this document.
						Our decision will be based on the available facts and evidence, and it will be made objectively and fairly, without undue delay.
					</li>
					<li>
						<strong className="text-uppercase mr-2">Put it right.</strong>
						Sometimes we get it wrong. When we do, we will take steps to put things right in a fair and proportionate manner.
						Sometimes we will owe you an apology. And sometimes we must change our procedures, improve employee training, or revise an earlier decision.
					</li>
				</ul>
				<p>Please feel free to call us at any time at 1-855-643-6945. Most customers resolve their concerns this way.</p>
				<p>If you are dissatisfied with the response, please take the steps explained below.</p>
				<h2 className="h4 border-bottom text-uppercase mt-5">Step 1. Write Us</h2>
				<p>If your concern has not been resolved with a phone call, please write a letter to us explaining your concern and how you would like us
					to resolve it.  In order to help us address your concern quickly, please include any information and documentation you think is relevant.
					Our decision will be made based on the available facts and evidence.</p>
				<table className="ml-3 ml-md-4 mb-3">
					<tbody>
						<tr>
							<th className="text-uppercase align-top pr-2">Write:</th>
							<td className="row">
								<div className="col-12 pb-2">
									First Canadian Insurance Corporation - Mosaic Life
								</div>
								<div className="col-12 pb-2">
									320 Sioux Road Sherwood Park, AB T8A 3X6
								</div>
								<div className="col-12">
									ATTENTION: Complaints Administration
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<p>Your complaint will be forwarded to the appropriate manager, who will review the issue and respond promptly in writing.</p>
				<p>If you are dissatisfied with the response, please take Step 2: Contact the Complaints Ombudsman.</p>
				<h2 className="h4 border-bottom text-uppercase mt-5">Step 2. Contact the complaints ombudsman</h2>
				<p>If your concern has not been resolved by writing us, please contact First Canadian’s Complaints Ombudsman. The Complaints
					Ombudsman provides a fresh set of eyes to review your file, and will ensure every attempt has been made to reach a fair and equitable solution.</p>
				<table className="ml-3 ml-md-4 mb-3">
					<tbody>
						<tr>
							<th className="text-uppercase align-top pr-2 pb-3">Email:</th>
							<td className="pb-3">
								<a href="mailto:ombudsman@firstcanadian.ca">ombudsman@firstcanadian.ca</a>
							</td>
						</tr>
						<tr>
							<th className="text-uppercase align-top pr-2">Write:</th>
							<td className="row">
								<div className="col-12 pb-2">
									First Canadian Insurance Corporation - Mosaic Life
								</div>
								<div className="col-12 pb-2">
									320 Sioux Road Sherwood Park, AB T8A 3X6
								</div>
								<div className="col-12">
									ATTENTION: Complaints Ombudsman
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<p>Please send your request in writing, explaining your concern, the history of your complaint, and how you would like us to resolve it.
					The Complaints Ombudsman will respond in writing within 30 days.</p>
				<h2 className="h4 border-bottom text-uppercase mt-5">Step 3. Contact the appropriate external agency</h2>
				<p>If you are not satisfied with our complaint resolution process, assistance and information is available through the
					national Ombudservice for life and health insurance companies.</p>
				<table className="ml-3 ml-md-4 mb-3">
					<tbody>
						<tr>
							<th className="text-uppercase align-top pr-2 pb-3">Write:</th>
							<td className="row pb-3">
								<div className="col-12 pb-2">
									OmbudService for Life and Health Insurance (OLHI) 
								</div>
								<div className="col-12 pb-2">
									401 Bay Street, PO Box 7
								</div>
								<div className="col-12">
									Toronto, Ontario M5H 2Y4
								</div>
							</td>
						</tr>
						<tr>
							<th className="text-uppercase align-top pr-2 pb-3">Website:</th>
							<td className="pb-3"><Link to="www.olhi.ca"><h6 className="mb-0">www.olhi.ca</h6></Link></td>
						</tr>
						<tr>
							<th className="text-uppercase align-top pr-2">Phone:</th>
							<td><a href="tel:1-888-295-8112">1-888-295-8112</a></td>
						</tr>
					</tbody>
				</table>				
				<p className="border-top mt-5 pt-3">
					As a provincially licensed and regulated insurance company, we are subject to the Insurance Act and Regulations
					of each province and territory.  Government regulatory bodies in each jurisdiction oversee the activities of insurance companies and provide assistance
					to consumers who may have inquiries or concerns.
				</p>
			</PageContent>
		</Page>
	);
};
export default ComplaintsPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/ComplaintsPage.tsx